<template>
  <div>
    <van-nav-bar
      safe-area-inset-top
      left-arrow
      @click-left="$router.back()"
      title="兑换记录"
      fixed
    />
    
    <div class="box-content" style="margin-top: 3.1rem;">
      <div class="div-conter">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div v-for="(item, index) in list" :key="index" class="van-hairline--bottom list-1">
            <!-- ROW -->
            <van-row type="flex" class="row-1">
              <van-col class="header-1">
                {{ item.giftName }}
              </van-col>
              <van-col class="align-right-flex">
                <van-tag :type="getVantType(item.status)">{{ getStatusDescription(item.status) }}</van-tag>
              </van-col>
            </van-row>
            <!-- ROW -->
            <van-row type="flex" class="row-1">
              <van-col class="body-1">
                <span class="header-1">兑换日期:</span> {{ DATE_TIME_FORMATTER.format(new Date(item.redeemDate)) }}
              </van-col>
              <van-col class="body-1 align-right-flex">
                {{ item.redeemPoint }}积分
              </van-col>
            </van-row>
            <!-- ROW -->
            <van-row type="flex" class="row-1">
              <van-col class="body-1 header-1">
                收货信息:
              </van-col>
            </van-row>
            <!-- ROW -->
            <van-row type="flex" class="row-1">
              <van-col class="body-1">
                {{ item.receiverName }}
              </van-col>
              <van-col class="body-1 align-right-flex">
                {{ item.receiverContact }}
              </van-col>
            </van-row>
            <!-- ROW -->
            <van-row type="flex" class="row-2">
              <van-col class="body-1">
                {{ item.shippingAddress }}
              </van-col>
              <van-col class="align-right-flex col-1" v-if="canBeCanceled(item.status)">
                <van-button type="info" size="small" round style="width: 5rem;" @click="cancelRedemption(item)">
                  取消 <van-icon name="clear" />
                </van-button>
              </van-col>
            </van-row>
          </div>
        </van-list>
      </div>
    </div>
    <div class="navigateBtn">
      <div class="navigateBtn-d1">
        <van-button round block type="info" @click="$router.back()">返回</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '../../api/api';
import { Toast } from 'vant';
import { Dialog } from 'vant';

export default {
  data() {
    return {
      pagingData: {
        page: 1, // 当前页码
        rows: 10, // 每页条数
        data: {
          userId: '3', // 用户ID
        },
      },
      list: [], // 兑换记录列表
      loading: false, // 加载状态
      finished: false, // 是否数据全部加载完成
      DATE_TIME_FORMATTER: new Intl.DateTimeFormat('zh-CN', {dateStyle: 'long'}),
    };
  },
  methods: {
    cancelRedemption(redemptionItem) {
      if (this.canBeCanceled(redemptionItem.status)) {
        // process cancellation
        Dialog.confirm({
          message: '取消兑换？',
          cancelButtonText: '返回',
          confirmButtonText: '确认',
        })
        .then(() => {
          return Api.cancelRedemption(redemptionItem.orderId)
            .then(() => {
              this.$router.push({
                path: "/app-h5-cn/page/success",
                query: {
                  headline:'3'
                }
              });
            })
            .catch(err => {
              Toast.fail('发生意外错误: ' + err.message ?? err);
            }) // cannot chain the 'then' as the Dialog object rejects the promise if the user select 'cancel'
        })
        .catch(() => {
          console.log('cancelled')
          // cancel
        });
      } else {
        Toast.fail('发生意外错误, 无法继续！');
      }
    },
    canBeCanceled(status) {
      if (status === 0) {
        return true;
      }
      return false;
    },
    getVantType(status) {
      switch(status) {
        case 0: return 'primary';
        case 1: return 'success';
        case 2: return 'danger';
        case 3: return 'danger';
        default: return '';
      }
    },
    getStatusDescription(status) {
      switch(status) {
        case 0: return '待发货';
        case 1: return '已发货';
        case 2: return '已取消';
        case 3: return '被管理员撤销';
        default: return '-';
      }
    },
    onLoad() {
      Api.redemptionList(this.pagingData)
        .then(res => {
          this.pagingData.page++;
          if (res.data && res.data.result) {
            res.data.result.list?.forEach(history => {
              this.list.push(history);
            });
            this.loading = false;
            if (this.list.length >= res.data.result.totalCount) {
              this.finished = true;
            }
          }
        });
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .van-nav-bar__title {
  color: black !important;
  font-size: 1rem;
  font-weight: 600;
}
/deep/ .van-nav-bar .van-icon {
  color: black;
}
/deep/ .van-nav-bar__text {
  font-size: 14px;
  color: #333333;
}
.box-content {
    // width: 100%;
    background-color: #fff;
    padding-top: 0.938rem;
    .div-conter {
      width: 92%;
      margin-left: 4%;
    }
}
.navigateBtn {
  width: 100vw;
  height: 4.6rem;
  position: fixed;
  background-color: white;
  bottom: 0px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .navigateBtn-d1 {
    width: 40%;
    /deep/ .van-button--info {
      background-color: (0,133,190);
      border: solid 1px white;
      width: 100%;
    }
  }
}
.header-1 {
  font-weight: 600;
}
.text-normal {
  color: #555555;
}
.align-right-flex {
  margin-left: auto;
}
.body-1 {
  color: #555555;
  font-size: 0.875rem;
}
.row-1 {
  margin-bottom: 0.5rem;
}
.row-2 {
  flex-wrap: nowrap;
}
.list-1 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.col-1 {
  flex: 0 0 auto;
  margin-top: auto;
}
</style>